"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/TeamPage/KeywordsTab/CopyPrompts.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _ui = require('web/services/ui');
var _copy = require('./copy');






const CopyButton = ({ text }) => {
  const [isCopied, setIsCopied] = _react.useState.call(void 0, false)
  _react.useEffect.call(void 0, () => setIsCopied(false), [text])
  return (
    _react2.default.createElement('button', {
      type: "button",
      className: "team-page--keywords--link-btn",
      onClick: () => _ui.copyToClipboard.call(void 0, text).then(() => setIsCopied(true)).catch(() => undefined), __self: this, __source: {fileName: _jsxFileName, lineNumber: 16}}

      ,  isCopied ? 'Copied' : 'Copy' 
    )
  )
}

// The "Copy prompts" button and its popover: three ready-to-paste lines for
// the chosen keyword.
const CopyPrompts = ({ keywords, phoneNumber }) => {
  const id = _react.useId.call(void 0, )
  const ref = _react.useRef(null)
  const [isOpen, setIsOpen] = _react.useState.call(void 0, false)
  const [chosen, setChosen] = _react.useState.call(void 0, '')
  const keyword = _nullishCoalesce(keywords.find(k => k.Keyword === chosen), () => ( keywords[0]))

  _react.useEffect.call(void 0, () => {
    if (!isOpen) return undefined
    const onDown = (e) => {
      if (!_optionalChain([ref, 'access', _ => _.current, 'optionalAccess', _2 => _2.contains, 'call', _3 => _3(e.target )])) setIsOpen(false)
    }
    const onKey = (e) => { if (e.key === 'Escape') setIsOpen(false) }
    document.addEventListener('mousedown', onDown)
    document.addEventListener('keydown', onKey)
    return () => {
      document.removeEventListener('mousedown', onDown)
      document.removeEventListener('keydown', onKey)
    }
  }, [isOpen])

  if (!keyword) return null

  return (
    _react2.default.createElement('div', { className: "team-page--keywords--prompts", ref: ref, __self: this, __source: {fileName: _jsxFileName, lineNumber: 52}}
      , _react2.default.createElement('button', {
        type: "button",
        className: "team-page--keywords--outline-btn",
        'aria-expanded': isOpen,
        'aria-controls': `${id}-popover`,
        onClick: () => setIsOpen(o => !o), __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}}
, "Copy prompts"

      )
      ,  isOpen && (
        _react2.default.createElement('div', { id: `${id}-popover`, className: "team-page--keywords--popover", role: "dialog", 'aria-label': "Copy prompts" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 63}}
          , _react2.default.createElement('div', { className: "team-page--keywords--popover-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 64}}, "Copy prompts" )
          , _react2.default.createElement('div', { className: "team-page--keywords--muted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 65}}, "Patients only use keywords they know about. Paste these where patients will see them."

          )
          , _react2.default.createElement('div', { className: "team-page--keywords--popover-pick", __self: this, __source: {fileName: _jsxFileName, lineNumber: 68}}
            , _react2.default.createElement('label', { htmlFor: `${id}-keyword`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 69}}, "Keyword")
            , _react2.default.createElement('select', { id: `${id}-keyword`, value: keyword.Keyword, onChange: e => setChosen(e.target.value), __self: this, __source: {fileName: _jsxFileName, lineNumber: 70}}
              ,  keywords.map(k => _react2.default.createElement('option', { key: k.Keyword, value: k.Keyword, __self: this, __source: {fileName: _jsxFileName, lineNumber: 71}},  k.Keyword )) 
            )
            , _react2.default.createElement('span', { className: "team-page--keywords--muted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 73}}, "Straight quotes only, so each line stays one text."        )
          )
          ,  _copy.promptLines.call(void 0, keyword, phoneNumber).map(line => (
            _react2.default.createElement('div', { key: line.label, className: "team-page--keywords--prompt-row", __self: this, __source: {fileName: _jsxFileName, lineNumber: 76}}
              , _react2.default.createElement('div', { className: "team-page--keywords--prompt-label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 77}},  line.label )
              , _react2.default.createElement('div', { className: "team-page--keywords--prompt-text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 78}},  line.text )
              , _react2.default.createElement(CopyButton, { text: line.text, __self: this, __source: {fileName: _jsxFileName, lineNumber: 79}} )
            )
          ))
        )
      )
    )
  )
}

exports. default = CopyPrompts
